import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { catchError, from, map, of } from "rxjs";
import { AuthService } from "../services/auth.service";

/** Redirects unauthenticated users to /entrar, preserving the returnUrl */
export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  return from(auth.refreshToken()).pipe(
    map((token) => {
      if (token) {
        return true;
      }

      return router.createUrlTree(["/entrar"], {
        queryParams: { returnUrl: state.url },
      });
    }),
    catchError(() =>
      of(
        router.createUrlTree(["/entrar"], {
          queryParams: { returnUrl: state.url },
        }),
      ),
    ),
  );
};
